import { KYMW5300Component } from './kymw5300.component';

/**
 * ECカテゴリマスタ画面の値を管理するクラス
 *
 * @export KYMW5300Model
 * @class KYMW5300Model
 */
export class KYMW5300Model {
  // コンポーネント
  kYMW5300Component: KYMW5300Component;

  // 編集有無フラグ
  public isEdited = false;

  // 受注コード
  public orderCode = String('');

  // 在庫制限フラグ
  public stockLimitFlg = String('0');

  // カテゴリ一覧データ
  public categoryInfoList: Array<any> = [];
  public dbItems: Array<any> = []; // DB空の取得値を保持する

  // 画面紐づけ用
  public catalogId = String('');
  public toShowSeq = String('');
  public categoryCode = String('');
  public categoryName = String('');
  public categoryParentName = String('');
  public borderLineDiv = String('');
  public showDiv = Boolean(false);
  public sellAreaDivB = Boolean(false);
  public sellAreaDivN = Boolean(false);
  public sellAreaDivM = Boolean(false);
  public sellAreaDivW = Boolean(false);
  public sellAreaDivS = Boolean(false);
  public sellAreaDivSP = Boolean(false);
  public sellAreaDivEC = Boolean(false);
  public categoryDiv = Boolean(false);

  // 非活性用
  public btn_Update: boolean = <boolean>false;
  public btn_Delete: boolean = <boolean>false;
  public btn_Makeroot: boolean = <boolean>false;
  public btn_Addchild: boolean = <boolean>false;
  /**
   * クリーン
   */
  public clean(): void {
    // カテゴリ一覧データの初期化
    this.categoryInfoList = [];
  }

  /**
   * 引数のオブジェクトをArrayCollectionに変換して返却する。
   * （nullオブジェクト対応版：nullの場合、空のArreyCollectionを返却する）
   */
  public convObjectToArrayCollection(any: any): Array<any> {
    let retList: Array<any> = [];

    if (any != null) {
      retList = any;
    }

    return retList;
  }


  public getCategory(serverData: any) {
    // 検索結果のチェック
    if (serverData.Category == null) { // 該当データなしの場合
      // カテゴリ一覧クリア
      this.clean();
      return;
    }

    // DB取得値からプロパティを選んで自身にコピーする
    this.dbItems = serverData.Category;
    this.categoryInfoList = [];

    // カテゴリ一覧初期化処理  第１階層カテゴリデータの初期化処理
    for (let i = Number(0); i < this.dbItems.length; i++) {

      this.categoryInfoList.push(this.dbItems[i]);
      this.categoryInfoList[i].CategoryName = this.dbItems[i].ShowSeq + ':' + this.dbItems[i].CategoryName;
      this.categoryInfoList[i].SellAreaDivB = this.dbItems[i].SellAreaDiv.slice(7, 8);
      this.categoryInfoList[i].SellAreaDivN = this.dbItems[i].SellAreaDiv.slice(6, 7);
      this.categoryInfoList[i].SellAreaDivM = this.dbItems[i].SellAreaDiv.slice(5, 6);
      this.categoryInfoList[i].SellAreaDivW = this.dbItems[i].SellAreaDiv.slice(4, 5);
      this.categoryInfoList[i].SellAreaDivS = this.dbItems[i].SellAreaDiv.slice(3, 4);
      this.categoryInfoList[i].SellAreaDivSP = this.dbItems[i].SellAreaDiv.slice(2, 3);
      this.categoryInfoList[i].SellAreaDivEC = this.dbItems[i].SellAreaDiv.slice(1, 2);
      this.categoryInfoList[i].SellAreaDiv1 = this.dbItems[i].SellAreaDiv.slice(0, 1);
      this.categoryInfoList[i].CategoryDiv = this.dbItems[i].CategoryDiv;

      // 子カテゴリがあった場合 第２階層カテゴリデータの初期化処理
      if ('Category' in this.dbItems[i]) {
        const list2 = []; // 子カテゴリを仮に入れる配列を定義する
        for (let j = Number(0); j < this.dbItems[i].Category.length; j++) {
          // ソートにより、子カテゴリを取得し、仮置き配列に追加する
          list2.push(this.dbItems[i].Category[j]);
          list2[j].CategoryName = this.dbItems[i].Category[j].ShowSeq + ':' + this.dbItems[i].Category[j].CategoryName;
          list2[j].SellAreaDivB = this.dbItems[i].Category[j].SellAreaDiv.slice(7, 8);
          list2[j].SellAreaDivN = this.dbItems[i].Category[j].SellAreaDiv.slice(6, 7);
          list2[j].SellAreaDivM = this.dbItems[i].Category[j].SellAreaDiv.slice(5, 6);
          list2[j].SellAreaDivW = this.dbItems[i].Category[j].SellAreaDiv.slice(4, 5);
          list2[j].SellAreaDivS = this.dbItems[i].Category[j].SellAreaDiv.slice(3, 4);
          list2[j].SellAreaDivSP = this.dbItems[i].Category[j].SellAreaDiv.slice(2, 3);
          list2[j].SellAreaDivEC = this.dbItems[i].Category[j].SellAreaDiv.slice(1, 2);
          list2[j].SellAreaDiv1 = this.dbItems[i].Category[j].SellAreaDiv.slice(0, 1);
          list2[j].CategoryDiv = this.dbItems[i].Category[j].CategoryDiv;

          // 孫カテゴリがあった場合 第３階層カテゴリデータの初期化処理
          if ('Category' in this.dbItems[i].Category[j]) {
            const list3 = []; // 孫カテゴリを仮に入れる配列を定義する
            for (let k = Number(0); k < this.dbItems[i].Category[j].Category.length; k++) {
              // ソートにより、孫カテゴリを取得し、仮置き配列に追加する
              list3.push(this.dbItems[i].Category[j].Category[k]);
              list3[k].CategoryName = this.dbItems[i].Category[j].Category[k].ShowSeq +
                ':' + this.dbItems[i].Category[j].Category[k].CategoryName;
              list3[k].SellAreaDivB = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(7, 8);
              list3[k].SellAreaDivN = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(6, 7);
              list3[k].SellAreaDivM = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(5, 6);
              list3[k].SellAreaDivW = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(4, 5);
              list3[k].SellAreaDivS = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(3, 4);
              list3[k].SellAreaDivSP = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(2, 3);
              list3[k].SellAreaDivEC = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(1, 2);
              list3[k].SellAreaDiv1 = this.dbItems[i].Category[j].Category[k].SellAreaDiv.slice(0, 1);
              list3[k].CategoryDiv = this.dbItems[i].Category[j].Category[k].CategoryDiv;
            }
            // 第２階層カテゴリへ第３階層配列を追加
            list2[j].Category = [];
            list2[j].Category = list3;
          }
        }
        // 第１階層カテゴリへ第２階層配列を追加
        this.categoryInfoList[i].Category = [];
        this.categoryInfoList[i].Category = list2;
      }
    }
    this.kYMW5300Component.updateTreeView();

    // 編集フラグクリア
    this.isEdited = false;

    // カテゴリ表示時の活性制御
    this.kYMW5300Component.enableControlForDisplay();

    // フォーカス設定
    this.kYMW5300Component.tre_Category.focus();
  }
}
